// extracted by mini-css-extract-plugin
module.exports = {"customized":"_2fgMywrET8ulowXTPAucJ9"};